import { Link, useNavigate } from "react-router-dom";
import { LogOut, Receipt, Ticket, Trophy, UserRound } from "lucide-react";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useMemberAuth } from "../auth/MemberAuthContext";
import { useWallet } from "../services/wallet.service";

export function MemberProfileDropdown() {
  const { session, logout } = useMemberAuth();
  const wallet = useWallet();
  const navigate = useNavigate();

  if (!session) return null;

  const handleLogout = () => {
    void logout().then(() => navigate("/member/login", { replace: true }));
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          className="inline-flex items-center gap-2 rounded-full py-1 pl-1 pr-2 text-left text-white hover:bg-white/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white"
          aria-label="Account menu"
        >
          <Avatar className="h-8 w-8">
            <AvatarFallback className="bg-white text-xs font-bold text-[#003580]">
              {session.initials}
            </AvatarFallback>
          </Avatar>
          <span className="hidden max-w-[120px] truncate text-sm font-medium sm:inline">
            {session.fullName.split(" ")[0]}
          </span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-60 bg-white p-2">
        <DropdownMenuLabel className="font-normal">
          <p className="text-sm font-semibold text-[#1a1a1a]">{session.fullName}</p>
          <p className="text-xs text-[#595959]">
            {wallet.tierName} · {wallet.points.toLocaleString("en-IN")} pts
          </p>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem asChild>
          <Link to="/member/rewards" className="cursor-pointer">
            <Trophy className="mr-2 h-4 w-4" />
            Rewards
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <Link to="/member/trips" className="cursor-pointer">
            <Ticket className="mr-2 h-4 w-4" />
            Trips
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <Link to="/member/transactions" className="cursor-pointer">
            <Receipt className="mr-2 h-4 w-4" />
            Points activity
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <Link to="/member/profile" className="cursor-pointer">
            <UserRound className="mr-2 h-4 w-4" />
            Account
          </Link>
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem
          onClick={handleLogout}
          className="cursor-pointer text-red-600 focus:text-red-600"
        >
          <LogOut className="mr-2 h-4 w-4" />
          Sign out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
